import store from './index'

export function makeEntityExistsGuard (collection, failPath) {
  return (to, from, next) => {
    const selectedId = store.state[collection].selectedEntityId
    if (selectedId === to.params.id) {
      next()
    } else {
      store.dispatch(collection + '/select', to.params.id).then(() => {
        next()
      }, () => {
        next(failPath || '/')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/utils.js